import React from 'react';
import moment from 'moment';
import { InterviewedOnType } from './DetailCard';
import { generateTimeString } from 'src/utils/scorecard';

interface Props {
	data: InterviewedOnType;
}

const InterviewedOn = ({ data }: Props) => {
	const { startTime, duration } = data;
	const dateString = moment(startTime).format('DD MMMM YYYY');
	const timeString = generateTimeString(startTime, duration);

	return (
		<div className="pl-4 dark:border-[#9E9E9E] border-solid">
			<div className="text-gray-600 dark:text-[#E5FFFF] text-xs font-medium">Interviewed on</div>
			<div className="mt-2 text-sm font-normal text-gray-600 dark:text-[#F2F2F5]">{dateString}</div>
			<div className="text-xs font-normal text-gray-500 dark:text-[#C7C9D9]">{timeString}</div>
		</div>
	);
};

export default InterviewedOn;
